import React, { useState } from 'react'

// images
import volunteer1 from "../Assets/Images/Volunteers/volunteer1.jpg";
import volunteer2 from "../Assets/Images/Volunteers/volunteer2.jpg";
import volunteer3 from "../Assets/Images/Volunteers/volunteer3.jpg";
import volunteer4 from "../Assets/Images/Volunteers/volunteer4.jpg";
import volunteer5 from "../Assets/Images/Volunteers/volunteer5.jpg";
import volunteer6 from "../Assets/Images/Volunteers/volunteer6.jpg";

import '../Assets/Css/volunteers.css'


// nav
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { Navbar, Nav } from "react-bootstrap";
import logo from "../Assets/Images/Home/logo.png";

import axios from 'axios'
import { useToasts } from 'react-toast-notifications'
import { Spinner } from 'react-bootstrap'

function Volunteers() {
    const [formDetails, setFormDetails] = useState('');
    // const { name, email, phone, age, gender } = formDetails;
    const handleChange = e => {
        setFormDetails({ ...formDetails, [e.target.name]: e.target.value });
    }
    const [loading, setLoading] = useState(false);

    const { addToast } = useToasts();
    const handleSubmit = e => {
        e.preventDefault();
        setLoading(true);
        axios.post('https://mysuru-for-portfolio.herokuapp.com/api/volunteer', formDetails).then(res => {
            setLoading(false);
            if (res.data)
                addToast('Submitted Successfully', { appearance: 'success', autoDismiss: 'true' })
        }).catch(err => {
            setLoading(false);
            if (err.message)
                addToast('An error occured, try again!', { appearance: 'error', autoDismiss: 'true' })
        });
    }
    return (
        <>
            <Navbar className="fixed-top" expand="lg">
                <div className="container">
                    <a className="navbar-brand" href="/">
                        <img src={logo} alt="Mysuru logo" />
                    </a>
                    <Navbar.Toggle aria-controls="navbarSupportedContent">
                        <FontAwesomeIcon icon={faBars} className="nav-toggler" />
                    </Navbar.Toggle>
                    <Navbar.Collapse id="navbarSupportedContent">
                        <Nav className="ml-auto">
                            <li className="nav-item">
                                <a className="nav-link" href="/">
                                    Home
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="/#destinations">
                                    Featured destinations
                </a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="/covid-dashboard">
                                    Covid Cases
                </a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="/#shorcuts">
                                    Make plans
                </a>
                            </li>
                            <li className="nav-item active">
                                <a className="nav-link" href="/volunteers">
                                    Volunteers
                </a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="/contact-us">
                                    Contact us
                </a>
                            </li>
                        </Nav>
                    </Navbar.Collapse>
                </div>
            </Navbar>
            <section id="volunteers">
                <h1 className="section-heading">Volunteers of Mysuru  </h1>
                <div className="card-deck">
                    <div className="card">
                        <img src={volunteer1} className="card-img-top" alt="volunteer" />
                        <div className="card-body">
                            <h5 className="card-title">Snehasish Pati </h5>
                            <p className="card-text">Ph: +91 811 344 5678 <br />volunteer@mysuru.org</p>
                        </div>
                    </div>
                    <div className="card">
                        <img src={volunteer2} className="card-img-top" alt="volunteer" />
                        <div className="card-body">
                            <h5 className="card-title">Atman Das</h5>
                            <p className="card-text">Ph: +91 811 344 5678 <br />volunteer@mysuru.org</p>
                        </div>
                    </div>
                    <div className="card">
                        <img src={volunteer3} className="card-img-top" alt="volunteer" />
                        <div className="card-body">
                            <h5 className="card-title">Yashraj Jain </h5>
                            <p className="card-text">Ph: +91 811 344 5678 <br />volunteer@mysuru.org</p>
                        </div>
                    </div>
                </div>
                <div className="card-deck">
                    <div className="card">
                        <img src={volunteer4} className="card-img-top" alt="volunteer" />
                        <div className="card-body">
                            <h5 className="card-title"> Sara                                                        </h5>
                            <p className="card-text">Ph: +91 811 344 5678 <br />volunteer@mysuru.org</p>
                        </div>
                    </div>
                    <div className="card">
                        <img src={volunteer5} className="card-img-top" alt="volunteer" />
                        <div className="card-body">
                            <h5 className="card-title">Sonakshi </h5>
                            <p className="card-text">Ph: +91 811 344 5678 <br />volunteer@mysuru.org</p>
                        </div>
                    </div>
                    <div className="card">
                        <img src={volunteer6} className="card-img-top" alt="volunteer" />
                        <div className="card-body">
                            <h5 className="card-title">Robert </h5>
                            <p className="card-text">Ph: +91 811 344 5678 <br />volunteer@mysuru.org</p>
                        </div>
                    </div>
                </div>
            </section>
            <section id="Register">
                <h1 className="section-heading">Register as a Volunteer</h1>
                <form onChange={handleChange} onSubmit={handleSubmit}>
                    <div id="info">
                        <h5>To register yourself as a volunteer, fill this form</h5>
                    </div>
                    <div className="input">
                        <label className="label-for-input">
                            <span>Name:</span>
                            <input type="text" name="name" required placeholder="Your name" />
                        </label>
                    </div>
                    <div className="input">
                        <label className="label-for-input">
                            <span>E-mail:</span>
                            <input type="email" name="email" required placeholder="Your email" />
                        </label>
                    </div>
                    <div className="input">
                        <label className="label-for-input">
                            <span>Phone:</span>
                            <input type="tel" name="phone" required placeholder="Your Phone no" />
                        </label>
                    </div>
                    <div className="input">
                        <label className="label-for-input">
                            <span>Age:</span>
                            <input type="number" name="age" required min="1" max="120" placeholder="Your age" />
                        </label>
                    </div>
                    <div className="input">
                        <label className="label-for-input radio-input">
                            <span>Gender:</span>
                            <div>
                                <label className="radio"><input type="radio" name="gender" value="Male" required /><span>Male </span></label>
                                <label className="radio"><input type="radio" name="gender" value="Female" required /><span>Female </span></label>
                            </div>
                        </label>
                    </div>
                    {loading ?
                        <button type='submit' className='btn btn-block btn-theme'><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />Submitting..</button> :
                        <button type='submit' id="submit" className='btn btn-block btn-theme'>REGISTER</button>
                    }
                    {/* <div id="submit">
                        <input type="submit" value="REGISTER " />
                    </div> */}
                </form>
            </section>
        </>
    )
}

export default Volunteers
